import React, { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputTime from "../../helpers/InputTime";





function StawkaNew(props)
{    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({       
        kwota_netto: 0,
        stawka_vat: 0,
        nazwa: "",    
        typ_stawki: "_x_" ,   // - jednorazowa,

        naliczaj_z_gory: '_x_',


        opl_wyzywienie: '_x_',
        typ_posilku: '0',
        stawka_wliczona_w_czesne: '0',
        godzina_posilku: '00:00',
        korekta_z_gory: '0',
        termin_zgloszenia_nieobecnosci: '0', //pomijamy chwilowo..
        godzina_zgloszenia_nieobecnosci: '', //pomijamy...



        opl_czesne: '_x_',

        nalicz_gdy_nieobecny: '0',

        sposob_naliczania_godzin: '0',

        naliczanie_wlasne_symbol: '',

        archiwum: '0',

        info_na_dokumencie: '',
         
    });


    const typStawek = [
        { v: '_x_', title: ' - - - '  },
        { v: '0', title: 'Jednorazowa  (np. wpisowe)'  },
        { v: '1', title: 'Miesięczna (np. czesne)'    },
        { v: '2', title: 'Dzienna (np. wyżywienie całodzienne, śniadanie, obiad, ...)'    },
        { v: '3', title: 'Godzinowa (wg. czas spędzonego w placówce)'    },
        { v: '4', title: 'Nadgodzinowa (wg. czasu, który wykracza poza deklarowany w umowie)'    },
        { v: '5', title: 'Własny sposób (wg. ustaleń z eLizak)'    },
    ];


    const typPosilku = [      
        { v: '0', title: 'Brak informacji'  },
        { v: '1', title: 'Śniadanie I'  },
        { v: '2', title: 'Śniadanie II'  },
        { v: '3', title: 'Obiad'  },
        { v: '4', title: 'Podwieczorek'  },
    ];

    const spNaliczaniaGodzin = [    
        { v: '_x_', title: ' - - - '  },   
        { v: '0', title: 'Proporcjonalnie, według minut,'  },
        { v: 'r', title: 'Za każdą rozpoczętą godzinę'  },                  
        { v: 'x', title: 'Za każdą rozpoczętą godzinę (rano / popoludnie)'  }, 
    ];    


    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
     

        if(filedName == 'typ_stawki')
        {
            if(val == '1') //miesieczna
            {  
                setRow( { ...row, 
               
                    [filedName]: val,
                    [filedName+"_valid"]:correct,
                    ["naliczaj_z_gory"]:'1',
                    ["naliczaj_z_gory_valid"]:true,
                    ["opl_wyzywienie"]:'0',
                    ["opl_wyzywienie_valid"]:true,
                    ["typ_posilku"]:'0',
                    ["typ_posilku_valid"]:true,
                    ["stawka_wliczona_w_czesne"]:'0',
                    ["stawka_wliczona_w_czesne_valid"]:true,
                    ["godzina_posilku"]:'00:00',
                    ["godzina_posilku_valid"]:true,
                    ["korekta_z_gory"]:'0',
                    ["korekta_z_gory_valid"]:true,
                    ["opl_czesne"]:'1',
                    ["opl_czesne_valid"]:true,
                    ["nalicz_gdy_nieobecny"]:'0',
                    ["nalicz_gdy_nieobecny_valid"]:true,
                    ["sposob_naliczania_godzin"]:'0',
                    ["sposob_naliczania_godziny_valid"]:true
                 
                 } ); 

             
                

            }else
            if(val == '2') // dzinenna
            {
                setRow( {...row, 
                    [filedName]:val,
                    [filedName+"_valid"]:correct,
                    ["naliczaj_z_gory"]:'_x_',
                    ["naliczaj_z_gory_valid"]:false,
                    ["opl_wyzywienie"]:'_x_',
                    ["opl_wyzywienie_valid"]:false,
                    ["typ_posilku"]:'0',
                    ["typ_posilku_valid"]:true,
                    ["stawka_wliczona_w_czesne"]:'0',
                    ["stawka_wliczona_w_czesne_valid"]:true,
                    ["godzina_posilku"]:'00:00',
                    ["godzina_posilku_valid"]:true,
                    ["korekta_z_gory"]:'0',
                    ["korekta_z_gory_valid"]:true,
                    ["opl_czesne"]:'0',
                    ["opl_czesne_valid"]:true,
                    ["nalicz_gdy_nieobecny"]:'0',
                    ["nalicz_gdy_nieobecny_valid"]:true,
                    ["sposob_naliczania_godzin"]:'0',
                    ["sposob_naliczania_godziny_valid"]:true,
                 } );   
            }else
            if(val == '3' || val == '4') // godziny nadgodziny
            {
                setRow( {...row, 
                    [filedName]:val,
                    [filedName+"_valid"]:correct,
                    ["naliczaj_z_gory"]:'0',
                    ["naliczaj_z_gory_valid"]:true,
                    ["opl_wyzywienie"]:'0',
                    ["opl_wyzywienie_valid"]:true,
                    ["typ_posilku"]:'0',
                    ["typ_posilku_valid"]:true,
                    ["stawka_wliczona_w_czesne"]:'0',
                    ["stawka_wliczona_w_czesne_valid"]:true,
                    ["godzina_posilku"]:'00:00',
                    ["godzina_posilku_valid"]:true,
                    ["korekta_z_gory"]:'0',
                    ["korekta_z_gory_valid"]:true,
                    ["opl_czesne"]:'0',
                    ["opl_czesne_valid"]:true,
                    ["nalicz_gdy_nieobecny"]:'0',
                    ["nalicz_gdy_nieobecny_valid"]:true,
                    ["sposob_naliczania_godzin"]:'_x_',
                    ["sposob_naliczania_godziny_valid"]:false,
                 } );   
            }
            else 
            {
                setRow( {...row, 
                    [filedName]:val,
                    [filedName+"_valid"]:correct,
                    ["naliczaj_z_gory"]:'_x_',
                    ["naliczaj_z_gory_valid"]:false,
                    ["opl_wyzywienie"]:'0',
                    ["opl_wyzywienie_valid"]:true,
                    ["typ_posilku"]:'0',
                    ["typ_posilku_valid"]:true,
                    ["stawka_wliczona_w_czesne"]:'0',
                    ["stawka_wliczona_w_czesne_valid"]:true,
                    ["godzina_posilku"]:'00:00',
                    ["godzina_posilku_valid"]:true,
                    ["korekta_z_gory"]:'0',
                    ["korekta_z_gory_valid"]:true,
                    ["opl_czesne"]:'0',
                    ["opl_czesne_valid"]:true,
                    ["nalicz_gdy_nieobecny"]:'0',
                    ["nalicz_gdy_nieobecny_valid"]:true,
                    ["sposob_naliczania_godzin"]:'0',
                    ["sposob_naliczania_godziny_valid"]:true,
                 } ); 
            }
            
        }else 
        {
            setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
        }

    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const saveData = (e) => {


 

        if(row.nazwa.length < 2) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj nazwe' ,  "ok"  ,null); 
                return; 
            }


        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }


       
        if(e != null) 
            {
                e.target.innerHTML = "czekaj...";
            }
        
 
        props.mainView.setProgress(-2);

        var req =  row;

        console.log("Dane", req);


        fetch( Config.url + '/rest_v1_calc,stawki_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została dodana" , "ok" , null);    
                       if(props.onAdded != undefined) props.onAdded(res.result);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }




    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn');

       
        setRow({       
            kwota_netto: 0,
            stawka_vat: 0,
            nazwa: "",    
            typ_stawki: "_x_" ,   // - jednorazowa,
    
            naliczaj_z_gory: '_x_',
    
    
            opl_wyzywienie: '_x_',
            typ_posilku: '0',
            stawka_wliczona_w_czesne: '0',
            godzina_posilku: '00:00',
            korekta_z_gory: '0',
            termin_zgloszenia_nieobecnosci: '0', //pomijamy chwilowo..
            godzina_zgloszenia_nieobecnosci: '', //pomijamy...
    
    
            opl_czesne: '_x_',
    
            nalicz_gdy_nieobecny: '0',
    
            sposob_naliczania_godzin: '0',
    
            naliczanie_wlasne_symbol: '',
    
            archiwum: '0',

            info_na_dokumencie: '',
        });
    }     

 
    var itemTakNie = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie' }, 
        { v: '1', title: 'Tak' }, 
    ];

    var itemTakNieWyz = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie, jeśli zgosi do wyznaczonej godziny' }, 
        { v: '1', title: 'Tak, zawsze bez względu na status obecności' }, 
    ];

    var itemTakNieWyzZG = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie, podliczanie po zakończeniu miesiąca' }, 
        { v: '1', title: 'Tak, wylicz z góry ilość dni otwarcia placówki' }, 
    ];

       var itemsTermin = [
            {v: 0, title: "Wg. ust. systemu"   },
            {v: 1, title: "Dzień przed"   },
            {v: 2, title: "W dniu nieobecności dziecka"   },
        ];


    

    var dlg_view =  (

            <div className="dlg_window dlg_type_xx shadowx">

                    <div className="dlg_title">
                         Definicja stawki
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                         

                                        <div className="form_split"></div>

                                      
                                       

                                        <div className="form_control">
                                            <div className="fieldName">Nazwa stawki / Nazwa pozycji na rozliczeniu*</div>
                                            <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: np. Czesne, Danie I, Godziny pobytu, ... "} className=' w300 ' req='1' firstUp="1" />
                                        </div>


                                        <div className="form_control">
                                            <div className="fieldName">Kwota*</div>
                                            <InputDecimal   userData={props.userData} value={row.kwota_netto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kwota_netto" placeholder={"Nazwa: np. Czesne, Danie I, Godziny pobytu, ... "} className=' w100 ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_control">
                                            <div className="fieldName">Stawka VAT (%, np. 23)*</div>
                                            <InputDecimal   userData={props.userData} value={row.stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stawka_vat" placeholder={"Stawka: 0 "} className=' w100 ' req='1' firstUp="1" />
                                        </div>

 
                                        <div className="form_split"></div>

                                        <div className="form_control">
                                            <div className="fieldName">Typ / Sposób naliczania*</div>
                                            <InputCombo  items={typStawek} userData={props.userData} value={row.typ_stawki} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_stawki" placeholder={""} className='  ' req='1'   />
                                        </div>


                                       
                                  

                                        {
                                            row.typ_stawki == 0 && //jednorazowa...
                                            <div>
                                                
                                                <div className="form_control">
                                                    <div className="fieldName">Opłata naliczna z góry?*</div>
                                                    <InputCombo  items={itemTakNie} value={row.naliczaj_z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="naliczaj_z_gory" placeholder={""} className='  ' req='1'   />
                                                </div>

                                            </div>
                                        }


                                        {
                                            row.typ_stawki == 1 && //miesieczna...
                                            <div>
                                               
                                                <div className="form_control">
                                                    <div className="fieldName">Opłata naliczna z góry?*</div>
                                                    <InputCombo  items={itemTakNie} value={row.naliczaj_z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="naliczaj_z_gory" placeholder={""} className='  ' req='1'   />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Czy to jest CZESNE?</div>
                                                    <InputCombo  items={itemTakNie} value={row.opl_czesne} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opl_czesne" placeholder={""} className='  ' req='1'   />
                                                </div>


                                            </div>
                                        }


                                        {
                                            row.typ_stawki == 2 && //dzienna...
                                            <div>
                                                
                                                <div className="form_control">
                                                <div className="fieldName">Opłata naliczna z góry?*</div>
                                                    <InputCombo  items={itemTakNieWyzZG} value={row.naliczaj_z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="naliczaj_z_gory" placeholder={""} className='  ' req='1'   />
                                                </div>
 
                                                <div className="form_split"></div>
                                             
                                                <div className="form_control">
                                                    <div className="fieldName">Czy to jest opłata za wyżywienie?</div>
                                                    <InputCombo  items={itemTakNie} value={row.opl_wyzywienie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opl_wyzywienie" placeholder={""} className='  ' req='1'   />
                                                </div>

                                                {
                                                    row.opl_wyzywienie == 1 && 
                                                    <Fragment>
                                                           

                                                                <div className="form_control">
                                                                    <div className="fieldName">Typ posiłku</div>
                                                                    <InputCombo  items={typPosilku} value={row.typ_posilku} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_posilku" placeholder={""} className='  ' req='1'   />
                                                                </div>


                                                                <div className="form_control">
                                                                    <div className="fieldName">Godzina posiłku</div>
                                                                    <InputTime   value={row.godzina_posilku} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_posilku" placeholder={""} className='  ' req='1'   />
                                                                </div>


                                                                <div className="form_control">
                                                                    <div className="fieldName">Stawka wliczona w kwote czesnego?</div>
                                                                    <InputCombo  items={itemTakNie} value={row.stawka_wliczona_w_czesne} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stawka_wliczona_w_czesne" placeholder={""} className='  ' req='1'   />
                                                                </div>

                                                                {
                                                                    row.naliczaj_z_gory == 1 &&
                                                                    <div className="form_control">
                                                                        <div className="fieldName">Koryguj kwotę wg. nieobecności z poprzedniego miesiąca</div>
                                                                        <InputCombo  items={itemTakNie} value={row.korekta_z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="korekta_z_gory" placeholder={""} className='  ' req='1'   />
                                                                    </div>
                                                                }
                                                                
                                                                <div className="form_control">
                                                                <div className="fieldName">Naliczaj, gdy nieobecny</div>
                                                                <InputCombo  items={itemTakNieWyz} value={row.nalicz_gdy_nieobecny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nalicz_gdy_nieobecny" placeholder={""} className='  ' req='1'   />
                                                                </div>

                                                                         {
                                                                                row.nalicz_gdy_nieobecny == 0 &&
                                                                                <Fragment>
                                                                                    <div className="form_control">
                                                                                            <div className="fieldName">Do kiedy rodzic musi zgłosić nieobecność:</div>                                       
                                                                                            <InputCombo  items={itemsTermin} userData={props.userData} value={row.termin_zgloszenia_nieobecnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_zgloszenia_nieobecnosci" placeholder={""} className=' w200 '  />
                                                                                        </div>
                                                    
                                                                                        {
                                                                                            row.termin_zgloszenia_nieobecnosci != 0 &&
                                                                                            <div className="form_control">
                                                                                                <div className="fieldName">Do godziny: </div>                                
                                                                                                <InputTime userData={props.userData} value={row.godzina_zgloszenia_nieobecnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_zgloszenia_nieobecnosci" placeholder={""} className='  '  />                                  
                                                                                            </div>
                                                                                        }
                                                                                    
                                                                                </Fragment>
                                                                            }   


                                                    </Fragment>
                                                }
                                                
                                            </div>
                                        }

                                        {
                                            row.typ_stawki == 3 && //godzinowa...
                                            <div>
                                                
                                                <div className="form_control">
                                                    <div className="fieldName">Opłata naliczna z góry?*</div>
                                                    <InputCombo  items={itemTakNie} value={row.naliczaj_z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="naliczaj_z_gory" placeholder={""} className='  ' req='1'   />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Sposób naliczania godzin*</div>
                                                    <InputCombo  items={spNaliczaniaGodzin} userData={props.userData} value={row.sposob_naliczania_godzin} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sposob_naliczania_godzin" placeholder={""} className='  ' req='1'   />
                                                </div>

                                                <div className="form_control">
                                                    <div className="fieldName">Naliczać, gdy zgłoszono nieobecność?*</div>
                                                    <InputCombo  items={itemTakNie} userData={props.userData} value={row.nalicz_gdy_nieobecny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nalicz_gdy_nieobecny" placeholder={""} className='  ' req='1'   />
                                                </div>


                                                
                                                {
                                                                    row.naliczaj_z_gory == 1 &&
                                                                    <div className="form_control">
                                                                        <div className="fieldName">Koryguj kwotę wg. nieobecności z poprzedniego miesiąca</div>
                                                                        <InputCombo  items={itemTakNie} value={row.korekta_z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="korekta_z_gory" placeholder={""} className='  ' req='1'   />
                                                                    </div>
                                                                }

                                            </div>
                                        }     


                                        {
                                            row.typ_stawki == 4 && //nadgodzinowa...
                                            <div>
                                              
                                                <div className="form_control">
                                                    <div className="fieldName">Sposób naliczania godzin*</div>
                                                    <InputCombo  items={spNaliczaniaGodzin} userData={props.userData} value={row.sposob_naliczania_godzin} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sposob_naliczania_godzin" placeholder={""} className='  ' req='1'   />
                                                </div>

                                            </div>
                                        }   



                                        {
                                            row.typ_stawki == 5 && //wlasny sposob...
                                            <div>
                                        

                                                    <div className="form_control">
                                                        <div className="fieldName">Kod otrzymany od eLizaka*</div>
                                                        <InputText   userData={props.userData} value={row.naliczanie_wlasne_symbol} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="naliczanie_wlasne_symbol" placeholder={"Nazwa: @"} className=' w300 ' req='1' firstUp="1" />
                                                    </div>

                                            </div>
                                        }                                                                                                                      


                                        <div className="form_split"></div>

                                        <div>
                                        

                                        <div className="form_control">
                                            <div className="fieldName">Dopisek na dokumencie (opcjonalnie, np. zwolnienie z VAT na podstawie...)</div>
                                            <InputText   userData={props.userData} value={row.info_na_dokumencie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="info_na_dokumencie" placeholder={"Info: "} className=' w400 ' req='0' firstUp="0" />
                                        </div>

                                        </div>
                                


                                        <div className="form_split"></div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>dodaj</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;


    return  <React.Fragment>
                <div className="btn"    onClick={changeView} >dodaj nową stawkę </div> 
                {dlg_view} 
           </React.Fragment>
}


export default StawkaNew;